import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
const breakpoints = createBreakpoints({});

const spacing = (x: number): number => (window.innerWidth <= breakpoints.width('sm') ? 4 * x : 4 * x);

export default {
  spacing,
};
